import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultScholarshipPage from './Pages/DefaultScholarshipPage';
import WizardPage from './Pages/WizardPage';

const ScholarshipInvetoryRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:scholarshipId/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultScholarshipPage />
            </Route>
        </Switch>
        
    );
};

export default ScholarshipInvetoryRouter;
